module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens32-762072f89fd78af51b63429b8b01f7f7.jpg";